export default "<p>catalog-item-calculate works!</p>\n"